import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const NewsSection = () => {
  const { translations, language } = useLanguage();
  const news = translations?.news || [];
  
  const readMoreText = language === 'fr' ? 'Lire plus' : 'Read More';

  if (!news.length) return null;

  return (
    <section id="news" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1D1D1D]">
            {translations?.newsTitle}
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            {translations?.newsSubtitle}
          </p>
        </div>

        {/* News Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {news.map((article) => (
            <article
              key={article.id}
              className="bg-white overflow-hidden shadow-lg group hover:shadow-xl transition-shadow duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <span className="text-sm text-[#D4AF37] font-medium">
                  {article.date}
                </span>
                <h3 className="text-xl font-bold text-[#1D1D1D] mt-2 mb-3 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {article.excerpt}
                </p>
                <a
                  href={`#news-${article.id}`}
                  className="inline-flex items-center gap-2 text-[#CD0000] font-bold hover:gap-3 transition-all"
                >
                  {readMoreText} <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
